"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChampionshipHandicapCalculator = exports.GENDER_OPTIONS = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var react_1 = tslib_1.__importStar(require("react"));
var ImageUniversal_1 = require("../green-section/containers/ImageUniversal/ImageUniversal");
var SocialShare_1 = require("../green-section/Video/VideoDetail/SocialShare");
var ScreenInput_1 = require("./ScreenInput");
var ScreenResult_1 = tslib_1.__importDefault(require("./ScreenResult"));
require("./styles.less");
var util_1 = require("./util");
exports.GENDER_OPTIONS = {
    MALE: 'male',
    FEMALE: 'female',
};
function ChampionshipHandicapCalculator(_a) {
    var backgroundImage = _a.backgroundImage, champLogoImage = _a.champLogoImage, title = _a.title, defaultGender = _a.defaultGender, logoImage = _a.logoImage, ctaLink = _a.ctaLink, ctaLabel = _a.ctaLabel, ctaNewWindow = _a.ctaNewWindow, eventList = _a.eventList, scoreList = _a.scoreList, preselectedEvent = _a.preselectedEvent, authorMode = _a.authorMode, howToLink = _a.howToLink, howToText = _a.howToText;
    var HANDICAP_CALCULATOR_CTA_CLICKS = 'championship-course-handicap-calculator-cta-clicks';
    var HANDICAP_CALCULATOR_SHARES_CLICKS = 'championship-course-handicap-share-clicks';
    var HANDICAP_CALCULATOR_SUBMIT = 'championship-course-handicap-submitwwys';
    var getInitialGenderState = function () {
        return exports.GENDER_OPTIONS.FEMALE === defaultGender ? exports.GENDER_OPTIONS.FEMALE : exports.GENDER_OPTIONS.MALE;
    };
    var _b = react_1.useState(getInitialGenderState()), gender = _b[0], setGender = _b[1];
    var _c = react_1.useState(util_1.DEFAULT_SCORE), score = _c[0], setScore = _c[1];
    var _d = react_1.useState(''), handicapIndex = _d[0], setHandicapIndex = _d[1];
    var _e = react_1.useState(), event = _e[0], setEvent = _e[1];
    var _f = react_1.useState(false), eventPreselected = _f[0], setEventPreselected = _f[1];
    var _g = react_1.useState(), courseHandicap = _g[0], setCourseHandicap = _g[1];
    var _h = react_1.useState(false), averageScoreUsed = _h[0], setAverageScoreUsed = _h[1];
    var _j = react_1.useState(0), screen = _j[0], setScreen = _j[1];
    var _k = react_1.useState(''), errorMessage = _k[0], setErrorMessage = _k[1];
    react_1.useEffect(function () {
        var script = document.createElement('script');
        script.src = 'https://digital-plt.usga.org/handicap/v1/coursehandicap.js';
        script.async = true;
        document.body.appendChild(script);
        var courseEvents;
        if (!lodash_1.default.isEmpty(eventList)) {
            courseEvents = eventList.filter(function (item) {
                return item.event === preselectedEvent;
            });
        }
        if (lodash_1.default.size(courseEvents) === 1) {
            setEvent(courseEvents[0]);
            setEventPreselected(true);
        }
        return function () {
            document.body.removeChild(script);
        };
    }, []);
    var setDtm = function (props) {
        window.digitalData = window.digitalData || {};
        window.digitalData = $.extend(true, window.digitalData, props);
    };
    var trackDtm = function (ev, props, onDtmTrack) {
        if (window._satellite) {
            setDtm(props);
            window._satellite.track(ev);
            if (typeof onDtmTrack === 'function') {
                setTimeout(function () {
                    onDtmTrack(event, props, window.digitalData);
                }, 1000);
            }
        }
    };
    var handleReturnClick = function () {
        trackDtm(HANDICAP_CALCULATOR_CTA_CLICKS, { handicapCalculatorCTAButton: 'Start Over' });
        setErrorMessage('');
        setEvent(!eventPreselected ? null : event);
        setCourseHandicap(null);
        setGender(getInitialGenderState());
        setScore(null);
        setHandicapIndex('');
        setScreen(0);
    };
    var handleSubmitClick = function () {
        trackDtm(HANDICAP_CALCULATOR_CTA_CLICKS, { handicapCalculatorCTAButton: 'Submit' });
        runCHCalculation();
    };
    var getResultDescription = function () {
        if (lodash_1.default.isEmpty(event)) {
            return '';
        }
        return (react_1.default.createElement("div", { className: "s-result" },
            react_1.default.createElement("div", { className: "s-result-box" },
                react_1.default.createElement("div", null,
                    "Course Rating\u2122: ", courseHandicap === null || courseHandicap === void 0 ? void 0 :
                    courseHandicap.courseRating),
                react_1.default.createElement("div", null,
                    "Slope Rating\u00AE: ", courseHandicap === null || courseHandicap === void 0 ? void 0 :
                    courseHandicap.slopeRating),
                react_1.default.createElement("div", null,
                    "Par: ", courseHandicap === null || courseHandicap === void 0 ? void 0 :
                    courseHandicap.par),
                react_1.default.createElement("div", null,
                    "Course Handicap\u2122",
                    averageScoreUsed ? ' estimate' : '',
                    ": ", courseHandicap === null || courseHandicap === void 0 ? void 0 :
                    courseHandicap.handicap))));
    };
    var handleCTAClick = function () {
        trackDtm(HANDICAP_CALCULATOR_CTA_CLICKS, { handicapCalculatorCTAButton: 'Get a Handicap' });
        window.open(ctaLink || window.location.href + '/#', ctaNewWindow ? "_blank" : "_self");
    };
    var onSocialShare = function (network) {
        trackDtm(HANDICAP_CALCULATOR_SHARES_CLICKS, { handicapCalculatorSharesButton: network });
    };
    function getIndex() {
        if (!!handicapIndex) {
            return handicapIndex;
        }
        else if (!!score && score.text !== util_1.DEFAULT_SCORE.text) {
            return gender === exports.GENDER_OPTIONS.FEMALE ? score.femaleHandicap : score.maleHandicap;
        }
        else {
            return '';
        }
    }
    var runCHCalculation = function () {
        if (event && !lodash_1.default.isEmpty(event)) {
            var index = getIndex();
            var courseRating = gender === exports.GENDER_OPTIONS.FEMALE ? event.courseRatingF : event.courseRatingM;
            var slopeRating = gender === exports.GENDER_OPTIONS.FEMALE ? event.slopeRatingF : event.slopeRatingM;
            var par = gender === exports.GENDER_OPTIONS.FEMALE ? event.parF : event.parM;
            var valIndex = validateHandicapIndex(index);
            if (valIndex.valid) {
                // @ts-ignore
                var objCHI = CalculateCourseHandicap(index, courseRating, slopeRating, par, false);
                if (objCHI.returnCode === 0) {
                    setCourseHandicap({ handicap: objCHI.value, index: index, courseRating: courseRating, slopeRating: slopeRating, par: par });
                    setScreen(1);
                    trackDtm(HANDICAP_CALCULATOR_SUBMIT, {
                        gender: gender,
                        handicapIndex: handicapIndex,
                        score: !handicapIndex ? score === null || score === void 0 ? void 0 : score.text : "",
                        event: event === null || event === void 0 ? void 0 : event.event,
                    });
                }
                else {
                    setErrorMessage(objCHI.message);
                }
            }
            else {
                setErrorMessage(valIndex.message);
            }
        }
        else {
            setErrorMessage('Please check handicap and championship fields');
        }
    };
    // @ts-ignore
    var validateHandicapIndex = function (index) {
        var val = index;
        if (val !== '') {
            val = parseFloat(index);
        }
        if (lodash_1.default.includes(index, '+')) {
            val = -val;
            return validateValue(val, 'Handicap index', -9.9, 54.0);
        }
        else {
            return validateValue(val, 'Handicap index', -500, 54.0);
        }
    };
    // @ts-ignore
    var validateValue = function (val, field, min, max) {
        var testVal = val && !isNaN(val) ? parseFloat(val) : val;
        var response = { valid: false, message: '' };
        if (testVal === '') {
            response.message = field + " is empty";
        }
        else if (isNaN(testVal)) {
            response.message = field + " contains wrong data";
        }
        else if (testVal < min || testVal > max) {
            response.message = field + " contains out of bounds data";
        }
        else {
            response.valid = true;
        }
        return response;
    };
    var isWebView = window.location.href.includes('.mobile');
    // @ts-ignore
    return (react_1.default.createElement("section", { className: classnames_1.default('c-championship-handicap-calculator', authorMode ? 'author-mode' : '') },
        !isWebView && (react_1.default.createElement("div", { className: "s-image-background" }, !!backgroundImage && react_1.default.createElement(ImageUniversal_1.ImageUniversal, { image: backgroundImage, asBackground: true }))),
        react_1.default.createElement("div", { className: "s-content" },
            react_1.default.createElement("div", { className: "s-heading" },
                react_1.default.createElement("div", { className: "title-container" },
                    !!champLogoImage && react_1.default.createElement(ImageUniversal_1.ImageUniversal, { image: champLogoImage }),
                    react_1.default.createElement("div", { className: 'title-wrapper' },
                        react_1.default.createElement("h2", { className: "s-title" }, title),
                        preselectedEvent && event && event.text !== util_1.DEFAULT_EVENT.text && (react_1.default.createElement("h3", { className: "s-sub-title" }, event.text)),
                        screen === 1 && (react_1.default.createElement("div", { className: "result-description" }, getResultDescription()))))),
            react_1.default.createElement("div", { className: "s-main-container" },
                screen === 0 && (react_1.default.createElement("div", { className: "s-description" },
                    react_1.default.createElement("span", null, "Please enter your details to get your Target Score based on championship course setup."))),
                react_1.default.createElement("div", { className: "s-main" },
                    screen === 0 &&
                        react_1.default.createElement(ScreenInput_1.ScreenInput, { eventList: eventList, scoreList: scoreList, gender: gender, setGender: setGender, score: score, setScore: setScore, handicapIndex: handicapIndex, setHandicapIndex: setHandicapIndex, event: event, setEvent: setEvent, eventPreselected: eventPreselected, averageScoreUsed: averageScoreUsed, setAverageScoreUsed: setAverageScoreUsed }),
                    screen === 1 &&
                        react_1.default.createElement(ScreenResult_1.default, { howToText: howToText, howToLink: howToLink, averageScoreUsed: averageScoreUsed, handicap: (courseHandicap === null || courseHandicap === void 0 ? void 0 : courseHandicap.handicap) || '', par: (courseHandicap === null || courseHandicap === void 0 ? void 0 : courseHandicap.par) || 0, index: (courseHandicap === null || courseHandicap === void 0 ? void 0 : courseHandicap.index) || '' }),
                    react_1.default.createElement("div", { className: 's-error-container' }, screen === 0 &&
                        errorMessage &&
                        (react_1.default.createElement("div", { className: "s-error-message" }, errorMessage)))),
                react_1.default.createElement("div", { className: "s-footer" },
                    !!logoImage && react_1.default.createElement(ImageUniversal_1.ImageUniversal, { image: logoImage }),
                    screen === 0 &&
                        react_1.default.createElement("button", { className: "cta-submit", onClick: handleSubmitClick }, "Submit"),
                    screen === 1 &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("button", { className: "cta-return", onClick: handleReturnClick }, "Start Over"),
                            react_1.default.createElement("button", { className: "cta-link", onClick: handleCTAClick }, ctaLabel))),
                screen === 1 && (react_1.default.createElement(SocialShare_1.SocialShare, { height: "30px", width: "30px", shareText: title, onSocialShare: onSocialShare }))))));
}
exports.ChampionshipHandicapCalculator = ChampionshipHandicapCalculator;
